// TODO(Sergio): remove this disabled rule
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  AdobeDataLayer,
  ClickEventAnalytics,
  PageLoadAnalytics,
  PageLoadErrorAnalytics
} from '@com-delta-idp/mnx-utils';
import { ANALYTICS_EVENTS } from '../../../constants/utils/analytics.constant';
import { triggerCustomEvent } from '../events/events.utils';
import { LoggingService } from '../logging/logging.service';

declare const window: {
  adobeDataLayer: AdobeDataLayer[];
} & Window;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor(private logging: LoggingService) {}

  /** dispatchCustomEvent as a generic method that passes eventName
   * and detail to dispatch the custom event
   */
  dispatchCustomEvent<T>(eventName: string, detail: T) {
    triggerCustomEvent<T>(eventName, detail);
  }

  /**
   * Update the data layer object used by tealeaf | omniture | analytics
   */
  updateDataLayer<T>(
    property: string,
    data: T | string | undefined,
    path: string
  ) {
    try {
      const properties = path.split('.');
      const dataObject = properties.reduce(
        (prev: any, curr: any) => prev && prev[curr],
        window
      );
      if (dataObject) {
        dataObject[property] = data;
      }
    } catch (e) {
      this.logging.log('The data layer object is undefined');
    }
  }

  updateAdobeDataLayerAnalytics(data: AdobeDataLayer): void {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(data);
  }

  setAnalytics(
    analytics: PageLoadAnalytics | ClickEventAnalytics | PageLoadErrorAnalytics
  ): void {
    const options = {
      [ANALYTICS_EVENTS.PAGE_LOAD]: () => {
        if ((analytics as PageLoadErrorAnalytics).error == undefined) {
          const pageName = (analytics as PageLoadAnalytics).page.info.page_name;
          (
            analytics as PageLoadAnalytics
          ).page.info.page_name = `dal:${pageName}`;
        }
      },
      [ANALYTICS_EVENTS.CLICK]: () => {
        const pageName = (analytics as ClickEventAnalytics).click.page_section;
        (analytics as ClickEventAnalytics).click.page_section = `${pageName}`;
      },
      [ANALYTICS_EVENTS.ERROR]: () => {
        if ((analytics as PageLoadErrorAnalytics).error.type !== '') {
          const pageName = (analytics as PageLoadErrorAnalytics).page.info
            .page_name;
          (
            analytics as PageLoadErrorAnalytics
          ).page.info.page_name = `dal:${pageName}`;
        }
      }
    };

    const action =
      analytics.event === ANALYTICS_EVENTS.PAGE_LOAD
        ? ANALYTICS_EVENTS.PAGE_LOAD
        : analytics.event === ANALYTICS_EVENTS.CLICK
        ? ANALYTICS_EVENTS.CLICK
        : ANALYTICS_EVENTS.ERROR;

    options[action]();
    this.updateAdobeDataLayerAnalytics(analytics);
  }
}
